<romeo-spinner></romeo-spinner>
<app-header></app-header>
<div class="theApp-main">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
